import { render, staticRenderFns } from "./DesignRirekisho001Edit.vue?vue&type=template&id=39863158&scoped=true"
import script from "./DesignRirekisho001Edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekisho001Edit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekisho001Edit.vue?vue&type=style&index=0&id=39863158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39863158",
  null
  
)

export default component.exports